import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { ServiceService } from "../../services/service.service";
import { Router } from "@angular/router";

declare let $: any;
declare let swal: any;

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"]
})
export class LoginComponent implements OnInit {
  tanggalsekarang = Date();
  showError: boolean = false;
  message: string;

  gForm: FormGroup;

  keterangan: string;

  constructor(private router: Router, private service: ServiceService) {
    if (this.service.getLogin()) {
      this.router.navigate(["/dashboard"]);
    }
    this.keterangan = "";
  }

  ngOnInit() {
    this.gForm = new FormGroup({
      username: new FormControl(),
      password: new FormControl()
    });
    this.service.serviceGetSetting().subscribe(data => {
      if (data.success) {
        this.service.setSetting(data.setting);
        this.keterangan = data.setting.keterangan;
      } else {
        alert("Tidak dapat terhubung dengan server.");
        console.log("Error: Tidak dapat mengakses setting..");
      }
    });
  }

  actionLogin(form, btnLogin) {
    this.showError = false;
    $(btnLogin).prop("disabled", true);
    $(btnLogin)
      .find("i")
      .addClass("fa-circle-o-notch fa-spin");

    this.service.serviceLogin(form).subscribe(data => {
      if (!data.success) {
        this.message = data.message;
        this.showError = true;
        setTimeout(() => {
          this.showError = false;
        }, 30 * 1000);
      } else {
        this.service.setLogin(data);
        this.service.serviceGenSoal().subscribe(data => {
          if (data.success) {
            this.service.setSoal(data.soal);
            this.service.setNilai(data.nilai);
            this.service.setExtra(data.extra);
            this.service.setKategori(data.kategori);

            this.router.navigate(["/dashboard"]);
          }
        });
      }
      $(btnLogin).prop("disabled", false);
      $(btnLogin)
        .find("i")
        .removeClass("fa-circle-o-notch fa-spin");
    });
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts